import { FaBook, FaBrain, FaChartLine } from "react-icons/fa6";
import { FaVoteYea } from "react-icons/fa";

import { Button } from "@heroui/button";
import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@heroui/modal";
import { cn } from "@heroui/theme";
import { PrimaryButton } from "../PrimaryButton";
import { useNavigate } from "@remix-run/react";

export const CreateAccountForFreeModalContent = () => {
  const navigate = useNavigate();
  return (
    <ModalContent>
      {(onClose) => (
        <>
          <ModalHeader className="flex flex-col gap-1 font-bangers text-xl">
            Get Started For Free
          </ModalHeader>
          <ModalBody className="flex flex-col gap-4 text-sm">
            <p>
              Create an account for free to fast-track your way to a high-value
              man.
            </p>
            <CreateAccountBenefits className="mt-4" />
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              variant="light"
              onPress={onClose}
              className="font-bangers"
            >
              Close
            </Button>

            <PrimaryButton
              className="px-4"
              onClick={() => {
                onClose();
                navigate("/sign-up");
              }}
            >
              Create an Account
            </PrimaryButton>
          </ModalFooter>
        </>
      )}
    </ModalContent>
  );
};

export const CreateAccountBenefits = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div className={cn("flex flex-col gap-5 mx-4", className)}>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaBrain className="text-primary text-2xl w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none font-bangers text-primary">
            Adaptive Training
          </h1>
          <p className="text-sm leading-tight">
            The more you play, the more we learn about your style, strengths,
            and weaknesses. The game will adapt to you.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaChartLine className="text-success text-2xl  w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none text-success font-bangers">
            Track Progress
          </h1>
          <p className="text-sm leading-tight">
            Advanced analytics to track your progress and see where you need to
            improve. If you can measure it, you can improve it.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaBook className="text-teal-500 text-2xl  w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg font-bold leading-none font-bangers text-teal-500">
            Build your knowledge base
          </h1>
          <p className="text-sm leading-tight">
            Learn from the wisdom of the crowd. Vote and save your favorate
            responses from the community and access them anytime.
          </p>
        </div>
      </div>
      <div className="flex flex-row gap-4 justify-start items-start">
        <FaVoteYea className="text-secondary text-2xl w-1/12" />
        <div className="flex flex-col gap-1 w-11/12">
          <h1 className="text-lg text-secondary font-bold leading-none font-bangers">
            Influence the Game
          </h1>
          <p className="text-sm leading-tight">
            Vote on features, suggest improvements, and contribute to the
            community to shape the future of the game.
          </p>
        </div>
      </div>
    </div>
  );
};
